import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "UniversalDropdown";

const keys = addTranslations(RESOURCE_NAME, {
    reset: {
        en: "Reset",
        fr: "Réinitialiser",
    },
});

export function useUniversalDropdownTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
